import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import authReducer from "./slices/authSlice";
import themeReducer from "./slices/themeSlice";
import uiReducer from "./slices/uiSlice";
import rbacReducer from "./slices/rbacSlice";
import errorReducer from "./slices/errorSlice";
import workflowReducer from "./slices/workflowSlice";
import timelineReducer from "./slices/timelineSlice";
import sidePanelReducer from "./slices/sidePanelSlice";
import dispatchReducer from "./slices/dispatchSlice";
import branchReducer from "../feature/branch/branchSlice";
import userReducer from "../feature/user/userSlice";
import customerReducer from "../feature/customer/customerSlice";
import siteReducer from "../feature/site/siteSlice";
import orderReducer from "../feature/orders/orderSlice";
import stageReducer from "../feature/stageModule/store/stageSlice";
import stateReducer from "../master/state/stateSlice";
import colorReducer from "../master/color/colorSlice";
import cityReducer from "../master/city/citySlice"
import locationReducer from "../master/location/locationSlice"
import setReducer from "../master/set/setSlice"
import itemReducer from "../master/item/itemSlice"
import itemSubtypeDefinitionReducer from "../master/itemSubtypeDefinition/itemSubtypeDefinitionSlice"
import roleTypeReducer from "../master/roleType/roleTypeSlice"
import leadReducer from "../feature/leads/store/slices/leadSlice";
import contactReducer from "../feature/leads/store/slices/contactSlice";
import whatsappTemplateReducer from "../feature/leads/store/slices/whatsappTemplateSlice";
import stageMasterReducer from "../feature/leads/store/slices/stageMasterSlice";
import leadSourceReducer from "../feature/leads/store/slices/leadSourceSlice";
import dailySalesDashboardReducer from "../features/sales-executive/dashboard1/dailySalesDashboardSlice";
// import salesExecutiveDashboardReducer from "../features/sales-executive/dashboard2/salesExecutiveSlice";

const store = configureStore({
  reducer: {
    theme: themeReducer,
    auth: authReducer,
    rbac: rbacReducer,
    error: errorReducer,
    users: userReducer,
    customers: customerReducer,
    branches: branchReducer,
    sites: siteReducer,
    workflow: workflowReducer,
    timeline: timelineReducer,
    stages: stageReducer,
    state: stateReducer,
    color: colorReducer,
    city: cityReducer,
    location: locationReducer,
    set: setReducer,
    item: itemReducer,
    itemSubtypeDefinition: itemSubtypeDefinitionReducer,
    roleType: roleTypeReducer,
    ui: uiReducer,
    orders: orderReducer,
    sidePanel: sidePanelReducer,
    dispatch: dispatchReducer,
    leads: leadReducer,
    contacts: contactReducer,
    whatsappTemplates: whatsappTemplateReducer,
    stageMaster: stageMasterReducer,
    leadSource: leadSourceReducer,
    dailySalesDashboard: dailySalesDashboardReducer,
    // salesExecutiveDashboard: salesExecutiveDashboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: import.meta.env.MODE !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
